import React from 'react';
import { Legend } from 'recharts';

export const PIE_LEGEND_PROPS = {
  verticalAlign: 'bottom' as const,
  align: 'center' as const,
  iconType: 'circle' as const,
  iconSize: 10,
  wrapperStyle: {
    fontSize: 11,
    lineHeight: '18px',
    paddingTop: 6,
  },
};

export const PieChartLegend = () => <Legend {...PIE_LEGEND_PROPS} />;

export const PIE_CHART_MARGIN = { top: 4, right: 8, left: 8, bottom: 36 };
